import { GET_AWBS_OFFLINE_SUCCEEDED, CLEAR_AWBS_OFFLINE_DATA } from '../actions/actionTypes';

import Awb from '../../models/Awb';

const initialState: Awb[] = [];

export const awbsOfflineReducer = (state:Awb[] = initialState, action: any) => {

  switch (action.type) {

    case GET_AWBS_OFFLINE_SUCCEEDED:
      return [...action.payload ]; 
    case CLEAR_AWBS_OFFLINE_DATA:
      return [ ];
    default:
     return state;
  }
};